const imageCache = new Map();

export const preloadImage = (src) => {
  if (!src) return Promise.resolve();

  const cached = imageCache.get(src);
  if (cached?.status === 'loaded') {
    return Promise.resolve();
  }

  if (cached?.promise) {
    return cached.promise;
  }

  const promise = new Promise((resolve) => {
    const img = new Image();
    const markDone = () => {
      imageCache.set(src, { status: 'loaded' });
      resolve();
    };
    img.onload = markDone;
    img.onerror = markDone;
    img.decoding = 'async';
    img.referrerPolicy = 'no-referrer';
    img.src = src;
  });

  imageCache.set(src, { status: 'pending', promise });
  return promise;
};

export const isImageLoaded = (src) => imageCache.get(src)?.status === 'loaded';
